import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ActivityService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IActivity } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapActivityFromEntity, mapActivityFromModel, mapGetSubscriberEmailsExcel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;
const message = "Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!"
export function getActivity(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.getActivity(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityFromEntity(response.data.attributes["activity"] || {});

            if (!notFill) {
                dispatch(initialPageData<IActivity>(mapped));
            }
            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getActivityByLanguage(pageData: IActivity, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.getActivity(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityFromEntity(response.data.attributes["activity"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IActivity>(data));
            if (isOverride) {
                dispatch(updateActivity(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createActivity({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getActivity(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getActivities(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.getActivities(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityFromEntity(item)
            );
            dispatch(initialPageData<IList<IActivity[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getFeaturedActivities(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.getFeaturedActivities(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityFromEntity(item)
            );
            dispatch(initialPageData<IList<IActivity[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function createActivity(request: IActivity): ThunkResult<Promise<IActivity | null>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.createActivity(mapActivityFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapActivityFromEntity(response.data.attributes["activity"] || {});
        }
        return null;
    };
}

export function updateActivity(request: IActivity): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.updateActivity(mapActivityFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteActivity(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.deleteActivity(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function toogleFeaturedActivity(id: string, isFeaturedActivity:boolean, key:string, lang:string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.toogleFeaturedActivity(
          id,
          isFeaturedActivity,
          key,
          lang
        );
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }

        dispatch(showMessage(response.data.message || message , "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getSubscriberEmailsExcel(activtyId: string): ThunkResult<Promise<object[] | null>> {
    return async (dispatch) => {
        const service = new ActivityService();
        dispatch(toggleLoader());
        const response = await service.getSubscriberEmailsTotal(activtyId);
  
        dispatch(toggleLoader());
        if (response?.data?.attributes?.list) {
            const mapped = (response.data.attributes.list || []).map(item => mapGetSubscriberEmailsExcel(item));
            return mapped;
        }
        return null;
    };
  }
